import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useT } from "../i18n";

export const Splash = () => (
  <div className="flex min-h-screen items-center justify-center bg-rox-black">
    <span className="font-display text-3xl uppercase tracking-wide animate-pulse-dot">
      RO<span className="text-rox-orange">X</span>PAIR
    </span>
  </div>
);

export const ProtectedRoute = ({ children, requireProfile = true }) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Splash />;
  if (!user) return <Navigate to="/connexion" state={{ from: location.pathname }} replace />;
  if (requireProfile && !profile) return <Navigate to="/onboarding" replace />;
  return children;
};

export const AppShell = ({ children, narrow = false }) => (
  <div className={`mx-auto min-h-screen w-full max-w-md bg-rox-black md:border-x md:border-rox-line ${narrow ? "lg:max-w-[640px]" : "lg:max-w-[1150px]"} lg:border-x`}>{children}</div>
);

export const AppFooter = ({ className = "", withNav = true }) => {
  const { t } = useT();
  return (
    <footer className={`border-t border-rox-line px-5 py-8 lg:px-8 ${withNav ? "pb-28 lg:pb-8" : ""} ${className}`} data-testid="app-footer">
      <p className="text-xs text-rox-muted" data-testid="footer-legal">{t("footer_legal")}</p>
      <p className="mt-3 font-display text-sm uppercase tracking-wide text-rox-off" data-testid="footer-tagline">
        {t("footer_tagline")} <span className="text-rox-orange">ROXPAIR</span>
      </p>
    </footer>
  );
};
